import { useEffect, useRef } from 'react';
import useServiceData from '../../useServiceData';
import { useRequestsHandlerData } from '../../useRequestsHandlerData';
import { timeZones } from '../../../constants/shared/time/timeZones';
import { defaultStore, stores } from '../../../translations';
import { useService } from '../../../redux/reducer/service';
import { useUser } from '../../../redux/reducer/user';

export default function useCheckUserRegisterDate() {
  const { serviceData } = useService();
  const { isFirstEntry } = useUser();
  const { get, save } = useServiceData();
  const isCanAddToRegisterCounter = useRef({ isSettled: false, isHasAuth: false });

  useEffect(() => {
    if (!serviceData || !isFirstEntry) return;

    const authData = get('authData') ?? {};

    if (authData?.registerDate?.correspondsStore && authData?.registerDate?.correspondsMsk) return;

    const registerDate = getTodayTimestampWithTimezone(defaultStore);
    const registerDateMsk = getTodayTimestampWithTimezone(stores.ru);
    save('authData', {
      ...authData,
      registerDate: { correspondsStore: registerDate, correspondsMsk: registerDateMsk },
    });
  }, [serviceData, isFirstEntry]);

  useEffect(() => {
    const { current } = isCanAddToRegisterCounter;

    if (!serviceData || current.isSettled || !current.isHasAuth) return;

    const authData = get('authData') ?? {};
    save('authData', {
      ...authData,
      registerCounter: (authData.registerCounter ?? 0) + 1,
    });
    current.isSettled = true;
  }, [serviceData]);

  useRequestsHandlerData([
    {
      address: 'requestsUserAuth',
      fulfilled() {
        const { current } = isCanAddToRegisterCounter;
        if (!current.isSettled) current.isHasAuth = true;
      },
    },
  ]);
}

export function getTodayTimestampWithTimezone(store) {
  const timeZone = timeZones[store];
  const now = new Date();
  const [date, time] = now.toISOString().split('T');
  const dateWithTimeZone = `${date}T${time.split(':')[0]}:${timeZone}`;
  return new Date(dateWithTimeZone).getTime();
}
